/**
 * @module router/authorization
 * @description Rutas del módulo de autorizaciones de prestaciones.
 * Layout con tabs: Casos | Nueva solicitud | Configuración
 */

const authorizationRoutes = [
  {
    path: "/authorization",
    component: () =>
      import(
        /* webpackChunkName: "authorization" */ "../components/authorization/AuthorizationLayout.vue"
      ),
    children: [
      {
        path: "",
        name: "authorization",
        component: () =>
          import(
            /* webpackChunkName: "authorization" */ "../components/authorization/AuthorizationList.vue"
          ),
      },
      {
        path: "new",
        name: "authorization-new",
        component: () =>
          import(
            /* webpackChunkName: "authorization" */ "../components/authorization/AuthorizationForm.vue"
          ),
      },
      {
        path: ":id",
        name: "authorization-detail",
        component: () =>
          import(
            /* webpackChunkName: "authorization" */ "../components/authorization/AuthorizationDetail.vue"
          ),
      },
    ],
  },
];

export default authorizationRoutes;
